module.exports = "/assets/8f4bad80fc72ed523f3fa0ab051fdcfa.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/MA.png
// module id = 1607
// module chunks = 0